import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../utils/toast";
import { postFormDataRequest, postRequest } from "../../utils/api";
import QuillEditor from "./QuillEditor";
const AddKnowledgeCategoryArtical = () => {
    const { categoryId, articalId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // Main Plan Data State
    const [formData, setFormData] = useState({
        artical_cat_id: "",
        artical_id: 0,
        artical_title: "",
        artical_sort_order: "",
        artical_excerpt: "",
        artical_description: "",
        artical_publish_type: 0,
    });

    const getKnowledgeCategoryArticalDetails = async () => {
        setLoading(true);
        try {
            const payload = {
                _id: articalId
            }

            const res = await postRequest(
                "/knowledge/get-knowledge-category-artical-details",
                payload
            );

            if (res.status === "success") {
                setFormData({
                    artical_cat_id: res.data.artical_cat_id,
                    artical_id: res.data.artical_id,
                    artical_title: res.data.artical_title,
                    artical_sort_order: res.data.artical_sort_order,
                    artical_excerpt: res.data.artical_excerpt || "",
                    artical_description: res.data.artical_description,
                    artical_publish_type: res.data.artical_publish_type,
                });
            } else {
                showToast.error(res.message);
            }

        } catch (error: any) {
            showToast.error(error.message || "An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (articalId) {
            getKnowledgeCategoryArticalDetails();
        }
    }, [articalId]);

    const handlePublish = async () => {
        if (!formData.artical_title) {
            showToast.error("Title is required.");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                artical_cat_id: String(categoryId),
                artical_id: String(formData.artical_id),
                artical_title: formData.artical_title,
                artical_sort_order: formData.artical_sort_order,
                artical_excerpt: formData.artical_excerpt,
                artical_description: formData.artical_description,
                artical_publish_type: String(formData.artical_publish_type)
            }
            const res = await postRequest("/knowledge/add-knowledge-category-artical", payload);

            if (res.status === "success") {
                showToast.success(res.message);
                navigate("/knowledge-base-articals/" + categoryId);
            } else {
                showToast.error(res.message);
            }
        } catch (error: any) {
            showToast.error(error.message || "An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="hk-pg-wrapper">
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <header className="page-header">
                                <div>
                                    <div className="page-title">
                                        <h2 className="mb-0">New Artical</h2>
                                    </div>
                                    <p className="text-muted mb-0">Manage your documentation — categories, articles, and visibility.</p>
                                </div>
                            </header>
                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">
                                        <div className="row g-3">
                                            <div className="col-lg-8">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Artical Details</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row g-3">
                                                            <div className="col-lg-10">
                                                                <div className="form-group mb-0">
                                                                    <label>Title</label>
                                                                    <input type="text" name="artical_title" value={formData.artical_title} onChange={handleChange} className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-2">
                                                                <div className="form-group mb-0">
                                                                    <label>Sort Order</label>
                                                                    <input type="text" name="artical_sort_order" value={formData.artical_sort_order} onChange={handleChange} className="form-control" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label>Excerpt (optional)</label>
                                                                    <textarea name="artical_excerpt" value={formData.artical_excerpt} onChange={handleChange} className="form-control"></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label>Description</label>
                                                                    {/*<textarea name="artical_description" value={formData.artical_description} onChange={handleChange} className="form-control"></textarea>*/}
                                                                    <QuillEditor
                                                                        name="artical_description"
                                                                        value={formData.artical_description}
                                                                        onChange={(name, value) =>
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                [name]: value
                                                                            }))
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h6>Publish</h6>
                                                    </div>

                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between align-items-center">

                                                                <div className="d-flex align-items-start gap-3">
                                                                    {formData.artical_publish_type === 1 ?
                                                                        <i className="ri-eye-line fs-5 text-muted mt-1"></i>
                                                                        : <i className="ri-eye-off-line fs-5 text-muted mt-1"></i>
                                                                    }
                                                                    <div>
                                                                        <div className="fw-semibold">
                                                                            {formData.artical_publish_type === 1 ? "Published" : "Draft"}
                                                                        </div>
                                                                        <div className="text-muted small">
                                                                            {formData.artical_publish_type === 1
                                                                                ? "Visible to public docs"
                                                                                : "Hidden from public docs"}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="form-check form-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        checked={formData.artical_publish_type === 1}
                                                                        onChange={(e) =>
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                artical_publish_type: e.target.checked ? 1 : 0
                                                                            }))
                                                                        }
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="card-footer">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handlePublish}
                                                            disabled={loading}
                                                        >
                                                            {loading ? 'Saving...' : 'Save'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddKnowledgeCategoryArtical